export default __webpack_public_path__ + "static/media/water.e23672dd.webp";